export const PARTNER_CONFIG = {
  // apiUrl: "https://whitelabel.staging-colossusbets.com/api",
  localesUrl: "//d18icbgk5z9c1l.cloudfront.net/i18n",
  imagesUrl: "//d20xk4sxen1bs2.cloudfront.net",
  fantasyStatsUrl: 'https://cb-stats-feed.staging-colossusbets.com/api',
  websocketsUrl: "ws-eu.pusher.com",
  websocketsKey: "f6d4e58b57dff09ba7ac",
  websocketCluster: 'eu',
  enableSyndicates: true,
  enableFreeplay: true,
  enableShare: true,
  allowResizeEvents: true,
  micrositeType: ['SPORTS'],
  twitterVia: '@TeamMatchBook',
  sharedTicketTitle: 'Matchbook',
  affiliatesUrl: 'https://www.matchbook.com/colossus?redirectUrl=[REDIRECT_URL]',
  scopes: ['locales', 'competitors', 'syndicates', 'sharing'],
  shareListEnabled: true,
  shareListTextDynamic: false,
  rulesDocs: {
    default: '2PACX-1vQo-o2mrHfhkd8jftFzLZ3MhsN0VnecUsEWrQoJ6Q-NWCN0SURYcl05IBAAWJm8q7j6M5wv5t9TMCAh',
    en: '2PACX-1vQo-o2mrHfhkd8jftFzLZ3MhsN0VnecUsEWrQoJ6Q-NWCN0SURYcl05IBAAWJm8q7j6M5wv5t9TMCAh'
  },
  allowLinkCopy: false,
  templateServiceUrl: 'https://templates.colossusbets.com/?uuid=[UUID_CODE]&merchant=matchbook',
  enableVideoStreaming: false,
  videoStreamingSport: ['GREYHOUNDS'],
  videoStreamUrl: 'https://v.sis.tv/StreamingService/api/v2/stream?',
  merchant_code: 'MATCHBOOK',
  streamUrl: '/streams',
  silksUrl: 'https://s3.eu-west-2.amazonaws.com/',
  allowRightSideWidget: true,
  haveSyndicateScroll: false,
  enableSyndicatesLeaderboard: true,
  shareSyndicateDynamicText: true,
  ravenUrl: 'https://a145365740d94116b132da0341937d8d@o113114.ingest.sentry.io/4504213502164992',
  'modalLaunchCustomSettings': {
    cordova: false,
    iframe: true
  },
  additionalLeftNavMenu: false,
  haveGroupedTickets: true,
  fallbackSecureWSnonCB: true
};
